import Layout from "../components/lib/Layout/Layout";
import Navbar from "../components/lib/Navbar/Navbar";
import AuthForm from "../components/Auth/AuthForm";

function SignUp() {
  return (
    <div className="theme-admin bg-blue-100">
      <Layout>
        <Navbar />
        <AuthForm isSignup={true} />
      </Layout>
    </div>
  );
}

export default SignUp;
